<div class="flex flex-col">
  <div class="flex h-12 flex-row items-center gap-4">
    <pr-campaign-step-number [first]="true" [last]="false">
      <mat-icon class="icon-xs">flag</mat-icon>
    </pr-campaign-step-number>

    <div class="flex grow">
      @if (enrolledByRunRef(); as runRef) {
        Enrolled in&nbsp;<a
          [prBrandRouterLink]="
            (
              runRef
              | map: brandLinks.marketingCampaignRun
            ).segments
          "
        >
          Campaign Run
        </a>
      } @else {
        Enrolled in Campaign
      }
    </div>
    <div class="text-xs opacity-50">
      {{ campaignEntry().createdAt | moment | amDateFormat: dateFormat }}
    </div>

    <div class="flex min-w-[96px] shrink-0 flex-row justify-end">
      <pr-campaign-step-conversion-status [status]="completedStatus" />
    </div>
  </div>

  <div class="flex h-12 flex-row items-center gap-4">
    <pr-campaign-step-number [first]="false" [last]="false">
      <mat-icon class="icon-xs" fontSet="material-symbols">move_item</mat-icon>
    </pr-campaign-step-number>

    <div class="flex grow">
      @if (!isPreview()) {
        Approved in&nbsp;<a
          [prBrandRouterLink]="
            (
              campaignEntry().campaignRunRef
              | map: brandLinks.marketingCampaignRun
            ).segments
          "
        >
          Campaign Run
        </a>
      } @else {
        Waiting Approval
      }
    </div>
    @if (!isPreview()) {
      <div class="text-xs opacity-50">
        {{
          (campaignEntry().startedAt ?? campaignEntry().createdAt)
            | moment
            | amDateFormat: dateFormat
        }}
      </div>
    }

    <div class="flex min-w-[96px] shrink-0 flex-row justify-end">
      <pr-campaign-step-conversion-status
        [status]="isPreview() ? pendingStatus : completedStatus"
      />
    </div>
  </div>

  @for (
    step of steps$ | async;
    track step.stepConversion.ref.path;
    let index = $index;
    let isLast = $last
  ) {
    <div class="flex h-12 flex-row items-center gap-4">
      <pr-campaign-step-number
        [active]="step.stepConversion | map: showActiveStep : this"
        [first]="false"
        [last]="isLast"
      >
        {{ index + 1 }}
      </pr-campaign-step-number>

      <pr-campaign-step-icon [campaignStep]="step.stepConfig" />
      <div class="flex grow flex-row items-center gap-2">
        <pr-campaign-step-header [campaignStep]="step.stepConfig" />
      </div>
      @if (step.stepConversion | map: showStepDate : this) {
        <div class="text-xs opacity-50">
          @if (step.stepConversion | map: getStepDate | async; as stepDate) {
            {{ stepDate | moment | amDateFormat: dateFormat }}
          }
        </div>
      }
      <div class="flex min-w-[96px] shrink-0 flex-row justify-end">
        <pr-campaign-step-conversion-status
          [status]="step.stepConversion.status"
          [tooltip]="step.stepConversion | map: getStepConversionTooltip"
        />
      </div>
    </div>
  } @empty {
    <div class="flex h-12 flex-row items-center gap-4">
      <pr-campaign-step-number [first]="false" [last]="true"
        >?</pr-campaign-step-number
      >

      <div class="flex grow flex-row items-center gap-2">
        Awaiting Campaign Steps to be added
      </div>

      <div class="flex min-w-[96px] shrink-0 flex-row justify-end">
        <pr-campaign-step-conversion-status [status]="pendingStatus" />
      </div>
    </div>
  }
</div>
